import { queryOptions } from "@tanstack/react-query";
import { getMerchantProfile, retrieveMerchant } from "../api/roster/http.js";
const roster = {
  keys: {
    root: () => ["roster"]
  },
  // Methods
  retrieveLocation: (params) => queryOptions({
    queryKey: [...roster.keys.root(), "retrieveLocation", { params }],
    queryFn: async () => {
      const { retrieveLocation } = await import("../api/roster/rpc.js");
      return retrieveLocation(params);
    }
  }),
  listLocations: (params) => queryOptions({
    queryKey: [...roster.keys.root(), "listLocations", { params }],
    queryFn: async () => {
      const { listLocations } = await import("../api/roster/rpc.js");
      return listLocations(params);
    }
  }),
  updateLocation: () => ({
    mutationKey: [...roster.keys.root(), "updateLocation"],
    mutationFn: async (params) => {
      const { updateLocation } = await import("../api/roster/rpc.js");
      return updateLocation(params);
    },
    meta: {
      invalidates: [roster.keys.root()]
    }
  }),
  retrieveMerchant: () => queryOptions({
    queryKey: [...roster.keys.root(), "retrieveMerchant"],
    queryFn: () => retrieveMerchant()
  }),
  getMerchantProfile: () => queryOptions({
    queryKey: [...roster.keys.root(), "getMerchantProfile"],
    queryFn: () => getMerchantProfile()
  })
};
export {
  roster
};
//# sourceMappingURL=roster.js.map
